<script>
// Componente preterido. Use fluent-icon.
import { mapGetters } from 'vuex';
import EmojiGlyph from 'shared/components/emoji/EmojiGlyph.vue';

export default {
  components: { EmojiGlyph },
  props: {
    icon: { type: String, default: '' },
    iconSize: { type: [Number, String], default: 20 },
    emoji: { type: String, default: '' },
  },
  computed: {
    ...mapGetters({ uiSettings: 'getUISettings' }),
    isIconTypeEmoji() {
      const { icon_type: iconType } = this.uiSettings || {};
      return iconType === 'emoji';
    },
    showEmoji() {
      return this.isIconTypeEmoji && this.emoji;
    },
    showIcon() {
      return !this.showEmoji && this.icon;
    },
    className() {
      return {
        'icon--emoji': this.showEmoji,
        'icon--font': this.showIcon,
        [this.icon]: this.showIcon,
      };
    },
  },
};
</script>

<template>
  <EmojiGlyph v-if="showEmoji" :emoji="emoji" :class="className" />
  <fluent-icon
    v-else-if="showIcon"
    :size="iconSize"
    :icon="icon"
    class="flex-shrink-0"
    :class="className"
  />
</template>
